import { ETaskStatus } from '@constants';
import { Button, Divider, Popconfirm } from 'antd';
import { useTranslation } from 'react-i18next';

import { useMutateActivity, useProfile, useActivityForm } from '@/store';

type Props = {
  handleClose: (forceClose?: boolean) => void;
  sectionId: string;
};

export const DeleteActivity: React.FC<Props> = ({ handleClose, sectionId }) => {
  const { t } = useTranslation('CourseTranslations');
  const { isWorking, removeActivity } = useMutateActivity();
  const { data } = useActivityForm();
  const {
    roleCheck: { isManager, isTeacher },
    profile
  } = useProfile();

  const canRemoveActivity =
    data &&
    (isManager ||
      (isTeacher &&
        profile?._id === data?.createdBy?._id &&
        data.task &&
        data.task.assignee?._id === profile?._id &&
        data.task.statusInfo.currentStatus !== ETaskStatus.APPROVED));

  const handleRemove = () => {
    if (data?._id) {
      removeActivity({ activityId: data._id, sectionId }, { onSuccess: () => handleClose(true) });
    }
  };

  if (!canRemoveActivity) return null;

  return (
    <>
      <Divider />

      <Popconfirm onConfirm={handleRemove} title={t('DELETE_ACTIVITY_CONFIRM')}>
        <Button type="primary" block loading={isWorking} danger>
          {t('DELETE_ACTIVITY')}
        </Button>
      </Popconfirm>
    </>
  );
};
